export default __webpack_public_path__ + "static/media/arrow-right-up.44b8c9cd4313204e6bcd9386e8d56dbe.svg";